import { FC } from 'react';
import { ChevronLeft } from 'lucide-react';

interface BackButtonProps {
  onClick: () => void;
  label?: string;
}

export const BackButton: FC<BackButtonProps> = ({ onClick, label = 'Back' }) => {
  return (
    <button
      onClick={onClick}
      className="flex items-center gap-1 text-muted-foreground hover:text-foreground transition-colors"
      aria-label="Go back"
    >
      <ChevronLeft className="w-5 h-5" />
      <span className="text-sm font-medium">{label}</span>
    </button>
  );
};
